<template>
  <sidebar-menu
    width="300px"
    collapsed
    :menu="menu"
    @item-click="onItemClick"
  />
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import { SidebarMenu } from 'vue-sidebar-menu'
import '../../sass/elements/PcsNavbar.scss'
import "vue-sidebar-menu/src/scss/vue-sidebar-menu.scss"


export default {
  components: {
    SidebarMenu,
  },

  data: () => ({
    appName: window.config.appName,
    tabs: [],
    userMenu: [],
    groupID: '',
    isActive: null,
    mini: true,
  }),

  computed: {
    ...mapGetters({
      user: 'auth/user',
      events: 'getCompletedEvents',
      unread: 'email/unreadEmails',
      unreadChat: 'chat/unreadMessages',
      classId: 'auth/classId',
      getCompletedEvents: 'events/getCompletedEvents',
    }),
    menu: function() {
      let filteredTabs = this.tabs.filter(tab => {
        if (tab.showAfterEvent) {
          return this.getCompletedEvents.includes(tab.showAfterEvent)
        }
        return true
      })
      return [
        ...filteredTabs.map(tab => tab.href === '/email' ?
          {
            href: tab.href,
            title: tab.title,
            icon: {
              element: 'span',
              class: `${tab.icon} ${this.unread > 0 ? 'unread-badge' : ''}`,
              attributes: { count: this.unread }
            },
          } : tab.href === '/chat' ? {
            href: tab.href,
            title: tab.title,
            icon: {
              element: 'span',
              class: `${tab.icon} ${this.unreadChat > 0 ? 'unread-badge' : ''}`,
              attributes: { count: this.unreadChat }
            },
          } : tab
        ),
        {
          header: true,
          title: 'Account',
          hiddenOnCollapse: true,
        },
        {
          title: this.user.name,
          icon: {
            element: 'img',
            class: 'rounded-circle profile-photo mr-1 material-icons',
            attributes: { src: this.user.photo_url },
          },
          class: 'user-menu',
          child: (this.userMenu && this.userMenu.length > 0) ? this.userMenu :
          [
            {
              href: { name: 'settings' },
              title: 'Settings',
              icon: 'fa fa-cog',
            },
            {
              href: '/library',
              title: 'Back to Library',
              icon: 'fas fa-arrow-left'
            },
            {
              href: 'Logout',
              title: 'Logout',
              icon: 'fa fa-sign-out-alt',
            },
          ],
        },
      ]
    },
  },

  created() {

    axios.post('/api/pcs/tabs', {
      params: {
        pcs: localStorage.getItem('pcs'),
      },
    })
    .then(response => {
      this.tabs = response.data['settings']['tabs']
      this.userMenu = response.data['settings']['userMenu']

      document.getElementsByClassName('vsm--list')[0].lastChild.classList.add('firstLink')
      let temp = document.getElementsByClassName('vsm--item').length
    })
  },

  methods: {
    ...mapActions({
      _logout: 'auth/logout',
      clearState: 'events/clearState',
    }),
    async logout() {
      // Log out the user.
      await this._logout()
      await this.clearState()

      // Redirect to login.
      this.$router.push({ name: 'home' })
    },

    onItemClick(event, item, node) {
      switch (item.title) {
        case 'Logout':
          this.logout()
          break
      }
    },
  },
}
</script>

<style scoped lang="scss">

.v-sidebar-menu::v-deep {
  .unread-badge:after{
    content:attr(count);
    position: absolute;
    background: tomato;
    top: 0.1rem;
    left: 1.95rem;
    width:1.05rem;
    text-align: center;
    line-height: 0.95rem;
    font-size: 0.75rem;
    border-radius: 50%;
    color:white;
    border:1px solid tomato;
  }
}

.v-sidebar-menu {
  background-color: #f2f2f2;
}
</style>
